import { inject, Injectable } from '@angular/core';
import { AddressesBootstrapService } from '@lentau/address/application/services/addresses-bootstrap.service';
import { EarlyActionService } from './early-action.service';
import { CityRequestService } from '@lentau/city/application/city-request.service';
import { SemRedirectService } from '@lentau/seo/application/services/sem-redirect.service';
import { TelegramMiniAppBootstrapService } from './telegram-mini-app-bootstrap.service';

@Injectable({
  providedIn: 'root',
})
export class EagerLentaBootstrapCSRService {
  private addressBootstrapService: AddressesBootstrapService = inject(AddressesBootstrapService);
  private earlyActionService: EarlyActionService = inject(EarlyActionService);
  private cityRequestService: CityRequestService = inject(CityRequestService);
  private semRedirectService: SemRedirectService = inject(SemRedirectService);
  private telegramMiniAppBootstrapService: TelegramMiniAppBootstrapService = inject(TelegramMiniAppBootstrapService);

  public init(): void {
    this.cityRequestService.getCitiesListAndRegion();

    this.cityRequestService.getUserRegionByAddress();

    this.addressBootstrapService.initAddresses();

    this.earlyActionService.init();

    this.semRedirectService.init();
    this.telegramMiniAppBootstrapService.init();
  }
}
